import { useLoaderData } from "@tanstack/react-router";
import { logout as apiLogout } from "@/lib/api/auth";

interface User {
  id: string;
  email: string;
  name?: string;
  profilePicture?: string | null;
}

interface RootLoaderData {
  user: User | null;
}

export function useAuth() {
  const rootLoaderData = useLoaderData({ from: "__root__" }) as
    | RootLoaderData
    | undefined;
  const user = rootLoaderData?.user || null;

  return {
    user,
    isAuthenticated: !!user,
    isLoading: false, // Server-side auth doesn't have loading states
    logout: async () => {
      await apiLogout();
    },
  };
}
